import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Career } from 'src/app/interfaces/career';
import { CareerService } from 'src/app/services/career.service';
import { FormsModule } from '@angular/forms';
import { ReactiveFormsModule } from '@angular/forms';
@Component({
  selector: 'app-add-edit-career',
  templateUrl: './add-edit-career.component.html',
  styleUrls: ['./add-edit-career.component.css']
})
export class AddEditCareerComponent implements OnInit {
  form: FormGroup;
  loading: boolean = false;
  id: number;
  operacion: string = 'Agregar ';

  constructor(private fb: FormBuilder,
    private _careerService: CareerService,
    private router: Router,
    private toastr: ToastrService,
    private aRouter: ActivatedRoute) {
    this.form = this.fb.group({
      name: ['', Validators.required],
      duration: [null, Validators.required],
    })
    this.id = Number(aRouter.snapshot.paramMap.get('id'));
  }

  ngOnInit(): void {

    if (this.id != 0) {
      // Es editar
      this.operacion = 'Editar ';
      this.getCareer(this.id);
    }
  }

  getCareer(id: number) {
    this.loading = true;
    this._careerService.getCareer(id).subscribe((data: Career) => {
      this.loading = false;
      this.form.setValue({
        name: data.name,
        duration: data.duration
      })
    })
  }

  addCareer() {
    /*  console.log(this.form.value.name);
     console.log(this.form.get('name')?.value); */

    const career: Career = {
      name: this.form.value.name,
      duration: this.form.value.duration
    }
    this.loading = true;

    if (this.id !== 0) {
      // Es editar 
      console.log("Editado: "+ career);
      career.id = this.id;
      this._careerService.updateCareer(this.id, career).subscribe(() => {
        this.toastr.info(`El careero ${career.name} fue actualizado con exito`, 'Careero actualizado');
        this.loading = false;
        this.router.navigate(['/career']);
      })

    } else {
      // Es agregagar
      console.log("Agregado: "+ career);
      this._careerService.saveCareer(career).subscribe(() => {
        this.toastr.success(`El careero ${career.name} fue registrado con exito`, 'Careero registrado');
        this.loading = false;
        this.router.navigate(['/career']);
      })
    }
  }
}
